export default __webpack_public_path__ + "static/media/03.c2d435b3.png";